// npm packages
import React, { useState } from 'react';
import { Autoplay, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

// swiper slider
import 'swiper/css';
import 'swiper/css/scrollbar';

// hooks
import useWindowDimensions from '@/app/hooks/useWindowSize';

// utils
import { cn } from '@/utils/cn';
import { imageTypes, screenTypes } from '@/constants/types';
import { getImageUrl } from '@/utils/string';
import ImageComponentV2 from '../Image/ImageComponentV2';

function TopBrandsSlider({ data = [], className = '' }) {
  const [isEnd, setIsEnd] = useState(false);
  const [isBeginning, setIsBeginning] = useState(false);
  const windowDimensions = useWindowDimensions();

  const getImageDimensionUrl = (url) => {
    if (!url) {
      console.error('Invalid URL object:', url);
      return null;
    }

    const imageSize =
      windowDimensions.width > screenTypes.large
        ? url?.icon?.large
        : url?.icon?.small;

    return imageSize;
  };

  const mainClassName =
    '!pl-16 md:!pl-[calc((100vw-100%)/2+40px)] lg:!pl-[calc((100vw-100%)/2+40px)] xl:!pl-[calc((100vw-1200px)/2)] 2xl:!pl-[calc((100vw-1240px)/2)] 3xl:!pl-[calc((100vw-1440px)/2)] !pb-[22px] lg:!pb-[36px] !pt-[18px] lg:!pt-[40px]';

  const isEndClassName =
    '!pr-16 md:!pr-[calc((100vw-100%)/2+40px)] lg:!pr-[calc((100vw-100%)/2+40px)] xl:!pr-[calc((100vw-1200px)/2)] 2xl:!pr-[calc((100vw-1240px)/2)] 3xl:!pr-[calc((100vw-1440px)/2)] transition-all duration-1000 ease-in-linear';

  const isBeginningClassName =
    '!pl-16 md:!pl-[calc((100vw-100%)/2+40px)] lg:!pl-[calc((100vw-100%)/2+40px)] xl:!pl-[calc((100vw-1200px)/2)] 2xl:!pl-[calc((100vw-1240px)/2)] 3xl:!pl-[calc((100vw-1440px)/2)] transition duration-75 ease-in-linear';

  return (
    <div className={cn(className)}>
      <Swiper
        modules={[Autoplay, Scrollbar]}
        spaceBetween={20}
        slidesPerView="auto"
        scrollbar={{
          hide: false,
          draggable: true,
        }}
        onTransitionEnd={(swiper) => {
          if (swiper.isEnd) {
            setIsEnd(true);
          } else {
            setIsEnd(false);
          }
        }}
        onReachBeginning={(swiper) => {
          if (swiper.isBeginning) {
            setIsBeginning(true);
          } else {
            setIsBeginning(false);
          }
        }}
        className={cn(
          mainClassName,
          isEnd && isEndClassName,
          !isEnd && 'pr-0',
          isBeginning && isBeginningClassName,
          !isBeginning && 'pl-0',
        )}
      >
        {Array.isArray(data) && data?.length > 0
          ? data?.map((item, index) => (
              <SwiperSlide
                key={item?.id ?? index}
                className="!w-max !flex !justify-center xl:!justify-start"
              >
                <div
                  key={item?.id ?? index}
                  className="bg-pale-grey w-[120px] lg:w-[300px] h-[46px] lg:h-[120px] flex justify-center items-center p-2 lg:p-30 rounded-xl shadow-what-are-you-looking-for-box-shadow cursor-pointer hover:shadow-card-hover"
                >
                  <ImageComponentV2
                    src={
                      getImageDimensionUrl(item)
                        ? getImageUrl(getImageDimensionUrl(item))
                        : null
                    }
                    alt={item?.name?.en}
                    className="w-full h-full max-h-[150px] object-contain object-center"
                    type={imageTypes.wide}
                    width={300}
                    height={120}
                    loading="lazy"
                  />
                </div>
              </SwiperSlide>
            ))
          : null}
      </Swiper>
    </div>
  );
}

export default TopBrandsSlider;
